module.exports = __webpack_public_path__ + "img/img_upload.a006c8de.png";